module.exports = __webpack_public_path__ + "static/media/node.85458a67.png";